import PropTypes from 'prop-types'

const TotalClicksIcon = ({ title }: any) => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none">
    <title>{title}</title>
    <path
      d="M15.75 15.75L24.5 36.75L27.6045 27.6045L36.75 24.5L15.75 15.75Z"
      stroke="#9EA6AD"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.1243 28.1243L35.5495 35.5495"
      stroke="#9EA6AD"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.579 3.91821L13.9388 8.98796M8.988 13.9387L3.9165 12.579M24.4125 7.08746L20.699 10.801M10.7993 20.699L7.08925 24.4125"
      stroke="#9EA6AD"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

TotalClicksIcon.displayName = 'TotalClicksIcon'

TotalClicksIcon.propTypes = {
  title: PropTypes.string
}

TotalClicksIcon.defaultProps = {
  title: 'Total Clicks'
}

export default TotalClicksIcon
